import { ApolloLink } from '@apollo/client'

/**
 * @private only to be used in apolloClient.ts
 */
export const logTimeLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((data) => {
    const time = new Date().getTime() - operation.getContext().startRequest.getTime()
    operation.setContext({ timeRequest: time })

    return data
  })
})
